import React from "react";
import { motion } from "framer-motion";
import "./HeroSlider.css";

const HeroSlider = () => {
  return (
    <section className="hero-section">
      <video
        className="hero-video"
        src={require("../../assets/hero3-bg.mp4")}
        autoPlay
        loop
        muted
        playsInline
      ></video>

      <div className="hero-overlay"></div>

      <motion.div
        className="hero-content"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.5, ease: "easeOut" }}
      >
        <motion.h1
          className="hero-title"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 1 }}
        >
          Welcome to <span>Lyros Technologies</span>
        </motion.h1>

        <motion.p
          className="hero-subtitle"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.2, duration: 1 }}
        >
        we specialize in HR consulting, job-ready skill development, and end-to-end BPO services. Our goal is to help individuals grow professionally while enabling businesses to operate efficiently with skilled talent and innovative support solutions.
        </motion.p>

        <motion.a
          href="/contact"
          className="hero-button"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 2, duration: 0.8 }}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          Contact Us
        </motion.a>
      </motion.div>
    </section>
  );
};

export default HeroSlider;
